export const GET_CATEGORIES = "@iweb/GET_CATEGORIES"
export const UPDATE_CATEGORY = "@iweb/UPDATE_CATEGORY"
export const SELECT_CATEGORY = "@iweb/SELECT_CATEGORY"
export const CATEGORIES_ADDRESS_UPDATED = "@iweb/CATEGORIES_ADDRESS_UPDATED"
